import { HostActionIntent as e } from "./types/HostActionIntent.mjs";
import { toBookingRequestActions as t } from "./mappers/toBookingRequestActions.mjs";
import { toCalendarFeedActions as n } from "./mappers/toCalendarFeedActions.mjs";
import { toMessageRequestActions as ee, toUnreadMessageActions as te } from "./mappers/toChatActions.mjs";
import { toDebtActions as ne, toPayoutMethodActions as re, toRejectedPayoutActions as ie } from "./mappers/toFinanceActions.mjs";
import { toArrivalRoomNotReadyActions as ae, toRoomOutOfOrderActions as oe } from "./mappers/toHousekeepingActions.mjs";
import { toInvitationActions as se } from "./mappers/toInvitationActions.mjs";
import { toModificationActions as r, toOfferAwaitingPaymentActions as i } from "./mappers/toModificationActions.mjs";
import { toPropertyDraftActions as a, toSuspendedListingActions as o } from "./mappers/toPropertyActions.mjs";
import { toUnansweredReviewActions as s } from "./mappers/toReviewActions.mjs";
import { toVerificationActions as c } from "./mappers/toVerificationActions.mjs";
import { sortHostActions as l } from "./sortHostActions.mjs";
import { BookingInvitationStatus as u, BookingModificationStatus as d, BookingStatus as f } from "@maat/api-booking/types";
import { PermissionSlug as p, VerificationSubjectType as m } from "@maat/api-main/types";
import { useMemo as h } from "react";
import { useAuth as ce, useCheckPermission as g } from "@maat/store-auth";
import { useBookingInvitationsQuery as le, useBookingModificationsQuery as _, useBookingsByIdsQuery as ue, useBookingsQuery as de, useUnansweredReviewsQuery as fe } from "@maat/store-booking";
import { useConversationsQuery as pe, useMessageRequestsQuery as me } from "@maat/store-chat";
import { useBalanceQuery as he, useDebtSummaryQuery as ge, usePayoutRequestsQuery as _e, useWithdrawalMethodsQuery as ve } from "@maat/store-payments";
import { useBusinessVerificationQuery as ye, useHostPropertiesQuery as be, useHousekeepingAttentionQuery as xe, useIdentityVerificationQuery as Se, useListingsByIdsQuery as Ce, usePropertyDraftsQuery as v } from "@maat/store-main";
import { useUnhealthyIcalFeedsQuery as y } from "@maat/store-ical-sync";
//#region src/useHostActionsQuery.ts
var b = () => {
	let { activeWorkspaceId: b } = ce(), x = b ?? void 0, { hasPermission: S } = g(p.BookingsView), { hasPermission: C } = g(p.FinanceViewPayouts), { hasPermission: w } = g(p.ChatRead), { hasPermission: T } = g(p.VerificationView), { hasPermission: E } = g(p.PropertiesList), { hasPermission: D } = g(p.CalendarView), { hasPermission: O } = g(p.HousekeepingView), k = !!x && S, { items: A, hasNextPage: we } = de({ status: f.Pending }, { enabled: k }), { data: j } = _({ status: d.AwaitingApproval }, { enabled: k }), { data: M } = _({
		status: d.AwaitingPayment,
		initiated_by: "HOST"
	}, { enabled: k }), { items: N, hasNextPage: Te } = le({ status: u.Pending }, { enabled: k }), { data: P } = fe({ enabled: k }), F = C ? x : void 0, { data: I } = ge(F), { data: L } = he(F), { data: R } = ve(F), { data: z } = _e(F), B = !!x && w, { items: V } = pe(void 0, { enabled: B }), { data: H } = me({ enabled: B }), { data: U } = Se(!!x && T), { data: W } = ye(!!x && T), { data: G } = v({ enabled: !!x && E }), { items: K, hasNextPage: Ee } = be(void 0, { enabled: !!x && E }), { data: q } = y(x, { enabled: D }), { data: J } = xe({ enabled: !!x && O }), Y = h(() => [...j?.modifications ?? [], ...M?.modifications ?? []], [j?.modifications, M?.modifications]), { bookings: X } = ue(h(() => [...new Set(Y.map((e) => e.booking_id))], [Y])), { data: Z } = Ce(h(() => [...new Set([
		...N.map((e) => e.listing_id),
		...(P?.reviews ?? []).map((e) => e.listing_id),
		...(q ?? []).map((e) => e.listing_id)
	])].filter(Boolean), [
		N,
		P?.reviews,
		q
	])), { actions: Q, waiting: $ } = h(() => {
		let u = new Map(X.map((e) => [e.id, e])), d = new Map((Z ?? []).map((e) => [e.listing_id, e])), f = l([
			...t(A),
			...r(j?.modifications ?? [], u),
			...i(M?.modifications ?? [], u),
			...se(N, d),
			...ne(I),
			...re(L, R?.methods),
			...ie(z?.requests ?? []),
			...c(m.Identity, U?.verification),
			...c(m.Business, W?.verification),
			...a(G?.drafts ?? []),
			...o(K),
			...te(V),
			...ee(H ?? []),
			...s(P?.reviews ?? [], d),
			...n(q ?? [], d),
			...oe(J?.items ?? []),
			...ae(J?.items ?? [])
		]);
		return {
			actions: f.filter((t) => t.intent !== e.Waiting),
			waiting: f.filter((t) => t.intent === e.Waiting)
		};
	}, [
		A,
		j?.modifications,
		M?.modifications,
		N,
		I,
		L,
		R?.methods,
		z?.requests,
		U?.verification,
		W?.verification,
		G?.drafts,
		K,
		V,
		H,
		P?.reviews,
		q,
		J?.items,
		X,
		Z
	]);
	return {
		actions: Q,
		waiting: $,
		totalCount: Q.length + $.length,
		isPartialCount: !!(we || Te || Ee),
		isLoading: !x
	};
};
//#endregion
export { b as useHostActionsQuery };
